import axios from 'axios';

export default {
  install(Vue, options) {
    if (!options.hasOwnProperty('getSession')) {
      console.info('AxiosInterceptor::install() -> requires a valid getSession promise');
      return;
    }

    axios.defaults.timeout = 10000;

    axios.interceptors.request.use(config => {
      config.headers.Accept = 'application/json';
      config.headers['Content-Type'] = 'application/json';

      return options
        .getSession()
        .then(session => {
          config.headers.Authorization = ((session || {}).idToken || {}).jwtToken;
          return Promise.resolve(config);
        })
        .catch(err => {
          // No authenticated user: don't set auth header
          console.warn('AxiosInterceptor::catch()', err.message);
        });
    });
  }
};
